module.exports = __webpack_public_path__ + "img/rocket-1.d4dc82e5.svg";